/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IntegrationEventPccPatientLeadsInner } from './IntegrationEventPccPatientLeadsInner';
import {
    IntegrationEventPccPatientLeadsInnerFromJSON,
    IntegrationEventPccPatientLeadsInnerFromJSONTyped,
    IntegrationEventPccPatientLeadsInnerToJSON,
    IntegrationEventPccPatientLeadsInnerToJSONTyped,
} from './IntegrationEventPccPatientLeadsInner';

/**
 * 
 * @export
 * @interface IntegrationEventPccPatient
 */
export interface IntegrationEventPccPatient {
    /**
     * 
     */
    leads?: Array<IntegrationEventPccPatientLeadsInner>;
}

/**
 * Check if a given object implements the IntegrationEventPccPatient interface.
 */
export function instanceOfIntegrationEventPccPatient(value: object): value is IntegrationEventPccPatient {
    return true;
}

export function IntegrationEventPccPatientFromJSON(json: any): IntegrationEventPccPatient {
    return IntegrationEventPccPatientFromJSONTyped(json, false);
}

export function IntegrationEventPccPatientFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEventPccPatient {
    if (json == null) {
        return json;
    }
    return {
        
        'leads': json['leads'] == null ? undefined : ((json['leads'] as Array<any>).map(IntegrationEventPccPatientLeadsInnerFromJSON)),
    };
}

export function IntegrationEventPccPatientToJSON(json: any): IntegrationEventPccPatient {
    return IntegrationEventPccPatientToJSONTyped(json, false);
}

export function IntegrationEventPccPatientToJSONTyped(value?: IntegrationEventPccPatient | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'leads': value['leads'] == null ? undefined : ((value['leads'] as Array<any>).map(IntegrationEventPccPatientLeadsInnerToJSON)),
    };
}

